export default "__VITE_ASSET__CjH8MW2X__"